module.exports = __webpack_public_path__ + "static/media/test11.be4c3fed.jpeg";